<template>
    <ReactPage>
      <role-mapping-config-page></role-mapping-config-page>
    </ReactPage>
  </template>
  
  <script>
  import ReactPage from '../components/ReactPage.vue';
  
  export default {
    name: "RoleMappingConfig",
    components: {
      ReactPage
    }
  }
  </script>